var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ElSelectOptions"},_vm._l((_vm.item.options||_vm.ajaxOptions),function(o){return _c('el-option',{key:o[_vm.item.key],attrs:{"label":o[_vm.item.label],"value":o[_vm.item.key],"disabled":o[_vm.item.disabled]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }